<template>
	<el-cascader v-model="checked" :options="optionsRender" :props="props" @change="handleSelectChange" clearable></el-cascader>
</template>

<script>
import DistrictApi from '@/api/setting/districtApi.js';
export default {
	name: 'province_city_cascader',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		props: {
			type: Object,
			default: () => {
				return {
					//服务区域组件配置
					multiple: true,
					checkStrictly: true,
					emitPath: false,
					label: 'name',
					value: 'id'
				}
			}
		},
	},
	data() {
		return {
			options: [], //地区数据
			checked: [],
		}
	},
	watch: {
		value: {
			handler(newVal) {
				this.checked = newVal || [];
			},
			deep: true,
			immediate: true
		},
	},
	computed: {
		optionsRender() {
			const isAll = this.checked[0] === null; // 全国
			const options = JSON.parse(JSON.stringify(this.options));
			if (!this.checked.length) return options;
			options.forEach((province, index) => {
				if (index === 0) {
					province.disabled = !isAll;
					return;
				}
				province.disabled = isAll;
				province.children?.forEach(city => {
					city.disabled = isAll;
				});
			});
			return options;
		}
	},
	created() {
		// 获取省市列表数据
		this.getProvinceList();
	},
	methods: {
		/**
		 * @description: 获取省市列表数据
		 */
		getProvinceList() {
			DistrictApi.queryProvinceList(null, true).then(res => {
				if (res && res.code === '00000') {
					this.options = res.rows;
				}
			});
		},
		handleSelectChange(value) {
			console.log(value);

			this.$emit('input', value);
		}
	},
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
</style>
